/**
 * Auto-scroll horizontal lent en aller-retour sur un élément scrollable.
 * Pause au touch utilisateur (reprend 2 s après touchend depuis la position courante).
 * Désactivé si l'utilisateur a exprimé prefers-reduced-motion: reduce.
 *
 * @param {Element} slider     L'élément scrollable horizontalement (overflow-x: auto)
 * @param {Object}  [options]
 * @param {string}  [options.maxWidth='767.98px']  Active uniquement <= ce breakpoint (mobile par défaut)
 * @param {number}  [options.speed=0.8]            Pixels par frame (~48 px/s à 60fps)
 * @param {number}  [options.pauseAfterTouch=2000] Délai (ms) avant de reprendre après touchend
 */
export const initHorizontalAutoScroll = (slider, options = {}) => {
  if (!slider) {
    return
  }

  const {
    maxWidth = '767.98px',
    speed = 0.8,
    pauseAfterTouch = 2000
  } = options

  const mq = window.matchMedia(`(max-width: ${maxWidth})`)
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
  if (!mq.matches || reducedMotion.matches) {
    return
  }

  let pos = 0
  let dir = 1
  let isPaused = false
  let pauseTimer = null

  slider.addEventListener(
    'touchstart',
    () => {
      isPaused = true
      clearTimeout(pauseTimer)
    },
    {
      passive: true
    }
  )
  slider.addEventListener(
    'touchend',
    () => {
      clearTimeout(pauseTimer)
      pauseTimer = setTimeout(() => {
        pos = slider.scrollLeft
        isPaused = false
      }, pauseAfterTouch)
    },
    {
      passive: true
    }
  )

  const tick = () => {
    if (!isPaused) {
      pos += speed * dir
      const max = slider.scrollWidth - slider.clientWidth
      if (pos >= max) {
        pos = max
        dir = -1
      }
      if (pos <= 0) {
        pos = 0
        dir = 1
      }
      slider.scrollLeft = pos
    }
    requestAnimationFrame(tick)
  }
  requestAnimationFrame(tick)
}
